import React from "react";
import ContactForm from "../ContactForm";
import { motion } from "framer-motion";

const ContactFormModal = ({
  showContactForm,
  closeContactForm,
  onContactFormSubmit,
}) =>
  showContactForm && (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 ">
      <motion.div
        className="bg-white w-full max-w-2xl p-6 rounded-lg shadow-lg relative"
        whileHover={{ scaleX: 1.02 }}
      >
        <motion.button
          className="absolute top-2 right-2 text-black p-1 rounded-full hover:text-gray-900 font-bold font-body "
          onClick={closeContactForm}
          whileHover={{ y: -5 }}
        >
          X{/* &times; */}
        </motion.button>
        <div className="lg:ml-40">
          <ContactForm
            onClose={closeContactForm}
            onSubmit={onContactFormSubmit}
          />
        </div>
      </motion.div>
    </div>
  );

export default ContactFormModal;
